/**
 * EmptyArchivio — F-006 Phase 5 (IMPL-P5-005).
 *
 * Rendered ONLY when `status === 'empty'`: the user has no pratiche at all.
 * Distinct from `NoResultsState` (filters give zero hits but pratiche exist).
 *
 * CTA: "Registra la prima pratica" → `/app/pratiche/nuova`.
 */
import { Link } from 'react-router-dom';
import { Archive, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function EmptyArchivio() {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 rounded-lg border border-dashed bg-muted/20 px-6 py-16 text-center"
      data-testid="empty-archivio"
    >
      <Archive className="h-12 w-12 text-muted-foreground" aria-hidden="true" />
      <div className="space-y-2">
        <h2 className="text-lg font-semibold">Il tuo archivio è vuoto</h2>
        <p className="max-w-md text-sm text-muted-foreground">
          Non hai ancora registrato nessuna pratica. Inizia ora — la prima registrazione
          richiede solo pochi minuti.
        </p>
      </div>
      <Button asChild>
        <Link to="/app/pratiche/nuova">
          Registra la prima pratica
          <ArrowRight className="ml-1 h-4 w-4" aria-hidden="true" />
        </Link>
      </Button>
    </div>
  );
}
